import Skeleton from '@material-ui/lab/Skeleton'
import * as React from 'react'

import styled from 'styled-components'
import { createMuiTheme, ThemeProvider } from '@material-ui/core'

const ItemDiv = styled.div`
  display: flex;
  flex-direction: column;

  margin: 0 0 25px 0;
  width: 100%;
  background: linear-gradient(rgb(35, 35, 35), rgb(20, 20, 20));
  border-color: #323232;
  border-width: 1px;
  border-style: solid;
  border-radius: 15px;
`

const VideoThumbnailContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  border-radius: 10px;
  margin-bottom: 7.5px;

  @media (min-width: 62em) {
    border-radius: 15px;
  }
`

const VideoThumbnail = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background-color: black;

  @media (min-width: 62em) {
    border-radius: 15px;
  }
`

const DetailsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  margin: 10px;
  margin-top: -40px;
  z-index: 1;
`

const HeaderDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const VideoTitle = styled.div`
  color: white;
  text-align: left;
  font-weight: 700;
  font-size: 22px;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  margin-top: 10px;
`

const Details = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const Subtitle = styled.div`
  color: white;
  font-weight: 500;
  font-size: 1.1rem;
`

const CreatorDiv = styled.div`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  border-radius: 30px;
  height: 24px;
  background: #444;
  width: fit-content;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 8px;
`

const Creator = styled.div`
  font-weight: 500;
  color: white;
  overflow: hidden;
  margin-left: 8px;
  margin-right: 4px;
  font-size: 18px;
`

const theme = createMuiTheme({
  palette: {
    type: 'dark',
  },
})

export const SkeletonCard = (): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <ItemDiv>
        <VideoThumbnailContainer>
          <VideoThumbnail>
            <Skeleton animation="wave" variant="rect" width={'100%'} height={'100%'} />
          </VideoThumbnail>
        </VideoThumbnailContainer>
        <DetailsDiv>
          <CreatorDiv>
            <Skeleton animation="pulse" variant="circle" width={'25px'} height={'25px'} />
            <Creator>
              <Skeleton animation="wave" variant="text" width={'100px'} height={'25px'} />
            </Creator>
          </CreatorDiv>
          <HeaderDiv>
            <VideoTitle>
              <Skeleton animation="wave" variant="text" />
            </VideoTitle>
            <Details>
              <Subtitle>
                <Skeleton animation="pulse" variant="text" width={'50px'} />
              </Subtitle>
              <Subtitle>
                <Skeleton animation="pulse" variant="text" width={'50px'} />
              </Subtitle>
            </Details>
          </HeaderDiv>
        </DetailsDiv>
      </ItemDiv>
    </ThemeProvider>
  )
}

export default SkeletonCard
